import { FC, useEffect, useState } from 'react';
import { LandscapeIndicatorBaselineTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { fetchVerificationStatuses } from '../../../store/landscapeAPI/verificationStatus/reducers/verification-status.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import { ValueResponseDto } from '../../../store/landscapeAPI/value/dto/response/value-response.dto';
import { ValueSaveRequestDto } from '../../../store/landscapeAPI/value/dto/request/value-save-request.dto';
import { useParams } from 'react-router-dom';
import { ValueType } from '../../../store/landscapeAPI/value/value-type';
import { DEFAULT_VERIFICATION_STATUS_ID, getUUID } from '../../../utils/UUID';
import { ValueUpdateRequestDto } from '../../../store/landscapeAPI/value/dto/request/value-update-request.dto';
import { fetchLandscapeIndicatorDetailsById } from '../../../store/landscapeAPI/landscape/reducers/landscape-indicator.slice';
import {
  saveBaseline,
  updateBaseline,
} from '../../../store/landscapeAPI/value/reducers/baseline.slice';

interface LandscapeIndicatorBaselinePageProps {}

const LandscapeIndicatorBaselinePage: FC<
  LandscapeIndicatorBaselinePageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id, landscapeIndicatorId } = useParams();

  const [loading, setLoading] = useState<boolean>(true);
  const [baseline, setBaseline] = useState<ValueResponseDto>({
    date: '',
    qty: null,
    qtyUnit: null,
    time: null,
    timeUnit: null,
    compactIndicatorId: landscapeIndicatorId!,
    valuesType: ValueType.Baseline,
    verificationStatusId: '',
    verificationStatus: null,
    id: '',
    versionId: 0,
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    published: true,
  });

  const { verificationStatuses, status } = useSelector(
    (state: RootState) => state.verificationStatusSlice
  );

  useEffect(() => {
    if (!landscapeIndicatorId) {
      return;
    }
    dispatch(fetchLandscapeIndicatorDetailsById(landscapeIndicatorId))
      .unwrap()
      .then((resp) => {
        if (resp.baseline.length > 0) {
          setBaseline(resp.baseline[0]);
        }
        setLoading(false);
      });
  }, [landscapeIndicatorId, dispatch]);

  useEffect(() => {
    dispatch(fetchVerificationStatuses());
  }, [dispatch]);

  const handleOnChange = (baseline: ValueResponseDto) => {
    setBaseline(baseline);
  };

  const callbackFn = async (baseline: ValueResponseDto) => {
    if (baseline.id !== '') {
      const baselineToUpdate: ValueUpdateRequestDto = {
        indicatorId: '',
        qty: baseline.qty,
        qtyUnit: baseline.qtyUnit,
        time: baseline.time,
        timeUnit: baseline.timeUnit,
        compactId: id!,
        date: baseline.date,
        compactIndicatorId: landscapeIndicatorId!,
        verificationStatusId:
          baseline.verificationStatusId || DEFAULT_VERIFICATION_STATUS_ID,
        id: baseline.id,
        published: baseline.published,
      };
      await dispatch(updateBaseline(baselineToUpdate));
    } else {
      const baselineToSave: ValueSaveRequestDto = {
        indicatorId: '',
        qty: baseline.qty,
        qtyUnit: baseline.qtyUnit,
        time: baseline.time,
        timeUnit: baseline.timeUnit,
        compactId: id!,
        date: baseline.date,
        compactIndicatorId: landscapeIndicatorId!,
        verificationStatusId:
          baseline.verificationStatusId || DEFAULT_VERIFICATION_STATUS_ID,
        id: getUUID(),
        published: baseline.published,
      };
      await dispatch(saveBaseline(baselineToSave));
    }
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {!loading && (
        <LandscapeIndicatorBaselineTemplate
          verificationStatuses={verificationStatuses ?? []}
          baseline={baseline}
          handleOnChange={handleOnChange}
          callbackFn={callbackFn}
        />
      )}
    </>
  );
};

export default LandscapeIndicatorBaselinePage;
